module.exports = __webpack_public_path__ + "static/media/tds.8d12a97c.svg";